module.exports = __webpack_public_path__ + "img/tree-05-e-trunk.689dc335.png";